import React from 'react';

import {
  FormControlViewModelType,
  TabsPaneFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';

import FormControlContainer from './FormControlContainer';

interface Props {
  control: TabsPaneFormControlViewModel;
  formId: UniqueId;
}

const FormTabPaneControl: React.FC<Props> = ({ control, formId }) =>
  control.visible ? (
    <>
      {control.type === FormControlViewModelType.TABS_PANE &&
        control.children.map(child => (
          <FormControlContainer name={child} key={child} formId={formId} />
        ))}
    </>
  ) : (
    <></>
  );

export default FormTabPaneControl;
